import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course04 from "../../../course/course-04/course";
import lesson0402 from "../lesson-02/lesson";
import lesson0403 from "../lesson-03/lesson";
import lesson0404 from "../lesson-04/lesson";
import lesson0406 from "../lesson-06/lesson";
import lesson0407 from "../lesson-07/lesson";
import lesson0409 from "../lesson-09/lesson";
import lesson0418 from "../lesson-18/lesson";
import lesson0419 from "../lesson-19/lesson";
import lesson0420 from "../lesson-20/lesson";
import lesson0421 from "../lesson-21/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "beb17313-77ac-411d-8ab6-5b69800c12e8",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0402),
    lesson: lesson0402,
  },
  {
    id: "126887d7-0e16-44d3-8616-a99294cb7334",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0403),
    lesson: lesson0403,
  },
  {
    id: "a93a3328-dd7f-46a9-ba4f-fd6b8cd2d14f",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0404),
    lesson: lesson0404,
  },
  {
    id: "963cebd3-20f5-4685-8fe2-989c4f6ce49c",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0406),
    lesson: lesson0406,
  },
  {
    id: "740fb507-3546-4e05-b37b-4f29c8965fb3",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0407),
    lesson: lesson0407,
  },
  {
    id: "6523efc1-7bd1-4f03-8476-cf685c2fe7d4",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0409),
    lesson: lesson0409,
  },
  {
    id: "3d4599db-6c43-4122-8d1b-3e8d29d5522e",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0418),
    lesson: lesson0418,
  },
  {
    id: "a389ed3a-8fc5-493e-9113-b1f950a1d0c4",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0419),
    lesson: lesson0419,
  },
  {
    id: "a67a5c44-4614-4781-b097-4233f11e8ada",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0420),
    lesson: lesson0420,
  },
  {
    id: "35fe25a3-c748-4e94-99f6-f950c9638c06",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0421),
    lesson: lesson0421,
  },
];

export default lessonLinks;
